import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';
import { html } from 'htm/preact';
import algoliasearch from 'algoliasearch';
// import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { getAlgoliaResults } from '@algolia/autocomplete-preset-algolia';
import { autocomplete } from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';


export default class SearchLayerComponent extends Component {

  get SELECTORS() {
    return {
      closeBtn: '[data-search-close]',
      searchForm: '[data-search-form]',
      searchJsSubmit: '.js-search-submit',
      searchJsSubmitInput: '#search_field_box input',
      topSearchesWrapper: '.l-s__searches'
    };
  }

  get CSS_CLASSNAMES() {
    return {
      open: 'search-open'
    };
  }

  get CONST() {
    return {
      baseUrl: 'https://query-suggestions.eu.algolia.com',
      baseUri: '/1/configs',
      indexName: '/'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.searchForm = this.$component.querySelector(this.SELECTORS.searchForm);
    this.searchJsSubmit = this.$component.querySelector(this.SELECTORS.searchJsSubmit);
    this.searchFormUrlJs = this.searchForm.getAttribute('data-js-search-url');
    this.input = this.$component.querySelector('input');
    this.scrollY = 0;
    this.appID = this.$component.getAttribute('data-search-appID');
    this.apiKey = this.$component.getAttribute('data-search-apiKey');
    this.analyticsApiKey = this.$component.getAttribute('data-search-analyticsApiKey');
    this.topSearchesWrapper = document.querySelector(this.SELECTORS.topSearchesWrapper);
  }

  openLayer() {
    this.$component.classList.add(this.CSS_CLASSNAMES.open);
    if(window.matchMedia('(max-width: 991px)').matches) {
      let benefitBar = document.querySelector('[data-benefit-bar]');
      let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
      this.scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${barHeight}px`;
      document.body.style.width = '100%';
    }
    if(this.input != null) {
      this.input.focus();
    } else {
      let suggestionInput = document.querySelector('.aa-Input');
      if(suggestionInput != null) {
        suggestionInput.focus();
      }
    }
  }

  closeLayer() {
    this.$component.classList.remove(this.CSS_CLASSNAMES.open);
    if(window.matchMedia('(max-width: 991px)').matches) {
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, this.scrollY);
    }
  }

  listenClose() {
    if(!this.closeBtn) {
      return;
    }
    this.closeBtn.addEventListener('click', () => {
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
    });
  }

  getSuggestion(index, search = false) {
    let ctx = this;
    // X-Algolia-Application-Id: the application ID.
    // X-Algolia-API-Key: the admin API key for given application ID.
    const appId = this.appID;
    const apiKey = this.apiKey;
    const searchClient = algoliasearch(appId, apiKey);
    //
    autocomplete({
      debug: true,
      container: '#l-s__search',
      panelContainer: '#l-s__suggestions',
      placeholder: ctx.$component.dataset.searchPlaceholder ,
      detachedMediaQuery: 'none',
      getSources({ query }) {
        return [
          {
            sourceId: 'querySuggestions',
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: index,
                    query
                  }
                ]
              });
            },
            getItemUrl({ item }) {
              return item.url;
            },
            getItemInputValue({ item }) {
              return item.query;
            },
            templates: {
              header() {
                return '';
              },
              item({ item }) {
                let itemHtml;
                const options = {style:"currency", currency:item.currency , maximumFractionDigits: 2};
                if(item.name === 'CARTAREGALO') {
                  itemHtml = html`<div class="w-card-product small">
                      <a href="${item.link}" class="c-p-card__wrapper">
                        <div class="c-p-card__images">
                          <img class="c-p-card__images-index" src="${item.image_index}" alt="" />
                        </div>
                        <div class="c-p-card__details">
                          <div class="c-p-card__details-name">${item.title}</div>
                        </div>
                      </a>
                    </div>`;
                } else if((ctx.isSaleMode || item.specialPrice) && item.sale_price != '' && item.inSale == true) {
                  var originalPrice = item.price.toLocaleString(ctx.currentLocale, options);
                  var salePrice = item.sale_price.toLocaleString(ctx.currentLocale, options);
                  itemHtml = html`<div class="w-card-product small">
                      <a href="${item.link}" class="c-p-card__wrapper">
                        <div class="c-p-card__images">
                          <img class="c-p-card__images-index" src="${item.image_index}" alt="" />
                        </div>
                        <div class="c-p-card__details">
                          <div class="c-p-card__details-name">${item.title}</div>
                          <div class="c-p-card__details-prices">
                            <span class="c-p-card__price price-full">${originalPrice}</span>
                            <span class="c-p-card__price price-discount">${salePrice}</span>
                          </div>
                        </div>
                      </a>
                    </div>`;
                } else {
                  var originalPrice = item.price.toLocaleString(ctx.currentLocale, options);
                  itemHtml = html`<div class="w-card-product small">
                      <a href="${item.link}" class="c-p-card__wrapper">
                        <div class="c-p-card__images">
                          <img class="c-p-card__images-index" src="${item.image_index}" alt="" />
                        </div>
                        <div class="c-p-card__details">
                          <div class="c-p-card__details-name">${item.title}</div>
                          <div class="c-p-card__details-prices">
                            <span class="c-p-card__price price-full">${originalPrice}</span>
                          </div>
                        </div>
                      </a>
                    </div>`;
                }
                return itemHtml;
              },
              footer() {
                return '';
              }
            }
          }
        ];
      }
    });
  }

  // bind keyup
  bindSearch() {
    let self = this;
    let index = self.$component.dataset.searchEnv + '_' + self.$component.dataset.searchBrand.toLowerCase() + '_' + self.$component.dataset.searchCountry + '_' + self.$component.dataset.searchLanguage;
    self.getSuggestion(index);
  }

  inputEvent() {
    let self = this;
    let searchJsSubmitInput = document.querySelector(this.SELECTORS.searchJsSubmitInput);

    if(searchJsSubmitInput != null) {
      searchJsSubmitInput.addEventListener('input', () => {
        if(searchJsSubmitInput.value !== '') {
          self.searchJsSubmit.classList.remove('--darker-grey');
        } else {
          self.searchJsSubmit.classList.add('--darker-grey');
        }
      });
    }
  }

  jsSearchPage() {
    // get autocomplete value
    let autocompleteInput = this.$component.querySelector(this.SELECTORS.searchJsSubmitInput);
    // build url
    let url = this.searchFormUrlJs + '?text=' + autocompleteInput.value;
    // go to url
    window.location.href = url;
  }

  bindEvents() {
    let self = this;

    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.open, () => {
      self.openLayer();
    });

    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.close, () => {
      self.closeLayer();
    });

    // if suggestions are enabled, i want to keep the standard search working
    if(this.searchJsSubmit != null) {
      this.searchJsSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        // go
        self.jsSearchPage();
      });
      // enables Enter key to submit search
      this.searchForm.addEventListener('keypress', (e) => {
        if(e.keyCode === 13) {
          e.preventDefault();
          // go
          self.jsSearchPage();
        }
      });
    }
  }

  getTopSearches() {
    let ctx = this;
    let index = ctx.$component.dataset.searchEnv + '_' + ctx.$component.dataset.searchBrand.toLowerCase()+ '_' + ctx.$component.dataset.searchCountry + '_' + ctx.$component.dataset.searchLanguage;
    let url = '/action/ajax/algolia-top-searches?indexName=' + index;
    return doAjax({
      url: url,
      type: 'GET',
      success: function(searches) {
        ctx.log('Call Successful');
        try {
          for(let i=0; i < searches.length; i++) {
            if (i > 5) {
              break;
            }
            let searchContainer = document.querySelector('[data-searches-container]');
            searchContainer.appendChild(ctx.topSearchTemplate(searches[i]));
          }
          if(ctx.topSearchesWrapper != null) ctx.topSearchesWrapper.classList.remove('hidden');
        } catch(e) {
          console.warn("Algolia Top Searches response has failed.", e);
        }
      },
      error: function(xhr) {
        console.log(xhr);
      }
    });
  }

  topSearchTemplate(search) {
      console.log('SEARCHLAYER COMPONENT',search);
    let searchEl = document.createElement("div");
    searchEl.classList.add("l-s__searches-content-subtitle");
    let searchLink = document.createElement("a");
    searchLink.href = "/search?text=" + search;
    searchLink.innerText = search;
    searchEl.appendChild(searchLink);
    return searchEl;
  }

  render() {
    super.render();
    this.listenClose();
    this.bindEvents();
    // if is enabled
    if(this.$component.attributes['data-algolia-enabled'].nodeValue == 'true') {
      this.getTopSearches();
    }
    if(this.$component.attributes['data-algolia-enabled'].nodeValue == 'true' &&
      this.$component.attributes['data-search-suggestions'].nodeValue == 'true') {
      this.bindSearch();
      this.inputEvent();
    }
  }
}
